import { Col, Form, Row, Container } from 'react-bootstrap';
import { Helmet } from "react-helmet";

import { ApplicationService, StatisticService, JobList } from '../../../../Api';
import { useQuery,getColors } from '../../../../Utils';
import { CustomButton, JobTitle,DetailsJobSubtitle } from '../../../StyledComponents';
import { LoadingStates } from '../../../Enums'
import { Legals } from '../../../Legals';
import { Field, Formik } from "formik";
import { Preview } from '../../../Preview';
import { LogoImage } from '../../../LogoImage';
import { CustomApplicationData, CustomApplicationDataInterface } from './CustomApplicationData';
import { ModalContainer } from 'reoverlay';
import { useCookieConsent, CookieConsentProvider } from '../../../../CookieConsentContext';

// SubForms
import { PrivacyConsentSubForm, Schema as PrivacyConsentSchema } from './subforms/PrivacyConsent';
import { HoneyPotSubForm } from './subforms/HoneyPot';

interface FormComponentInnerProps {
    setUploadStatus: React.Dispatch<React.SetStateAction<LoadingStates>>; 
    jobList: JobList;
    validationSchema: any;
    children: any;
    logoUrl: string;
  }
  
const FormComponentInner = (props: FormComponentInnerProps) => {
    const query = useQuery();
    const previewMode = query.get("preview") !== null && query.get("preview") === "true";

    const colors = getColors(props.jobList,props.jobList.jobs[0]);
    const legalNoticeUrl = props.jobList.legalNoticeUrl
    const dataSecurityUrl = props.jobList.dataSecurityUrl
    const listId = props.jobList.id;

    const { consentGiven, openSettings, settingsDialogOpen, consentDialogOpen } = useCookieConsent();

    const getGohiringVariables = () => {
        var url = window.location.href
        var pos = url.indexOf("?pid=");
        if (pos > 0) {
            let vars = url.substring(pos + 5);
            if (vars.length > 0) {
                var pair = vars.split("&it=");
                return pair
            }
        }
        return [];
    }

    const submitForm = (values: CustomApplicationDataInterface) => {
        console.log(values);

        if (previewMode === true) {
            return;
        }

        // ckeck H.o.n.e.y.p.o.t
        if (values.name.length > 0 || values.email.length > 0) return;

        if (!props.jobList) return;
        let application = values.getApplication(props.jobList?.jobs[0].tenant, props.jobList?.jobs[0].id,listId)

        const data = new FormData()
        data.append('application', JSON.stringify(application))
        if (values.cvFile) data.append('cv', values.cvFile, values.cvFile.name)

        data.append('additionalFilesCount', values.additionalFiles == null ? '0' : values.additionalFiles.length.toString())
        if (values.additionalFiles) {
            for (let i = 0; i < values.additionalFiles.length; i++) {
                const element = values.additionalFiles[i];
                data.append('file' + i, element, element.name)
            }
        }

        props.setUploadStatus(LoadingStates.Pending);
        ApplicationService.postApplication(data).then(result => {
            if (result) {
                props.setUploadStatus(LoadingStates.Success);
                StatisticService.updateCounter(props.jobList?.jobs[0].tenant, props.jobList?.jobs[0].id, "FormApplicationCount").then(result => {
                    console.log("");
                }).catch(() => {
                    console.log("");
                });
            }
            else {
                props.setUploadStatus(LoadingStates.Fail);
            }
        }).catch(() => {
            props.setUploadStatus(LoadingStates.Fail);
        });
    }

    const schema = props.validationSchema.concat(PrivacyConsentSchema);

    const initialValues = new CustomApplicationData();
    const vars = getGohiringVariables();
    if (vars.length > 0) {
        initialValues.pid = vars[0];
        initialValues.it = vars[1];
    };

    return (
        <>
            {consentGiven && 
                <Helmet>
                    {/* <!-- Meta Pixel Code --> */}
                    <script>
                    {
                       `!function(f,b,e,v,n,t,s)
                       {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', '7167432393379174');
                        fbq('track', 'PageView');`
                    }</script>
                    <noscript>{`<img height="1" width="1" style="display:none"
                        src="https://www.facebook.com/tr?id=7167432393379174&ev=PageView&noscript=1"
                    />`}</noscript>
                    {/* <!-- End Meta Pixel Code --> */}
                </Helmet>
            }
            <Container fluid>
                <Container style={{ maxWidth: "800px", backgroundColor: "white" }}>
                    <Row>
                        <Col md={12} style={{ display: "flex", justifyContent: "right" }}>
                        </Col>
                        <Col md={12}>{
                            <div>
                                <div style={{ paddingTop: "30px" }}>
                                    <Row>
                                        <Col style={{ display: "flex", justifyContent: "left" }}>
                                            <LogoImage url={props.jobList.jobs[0].hiringOrganization?.sameAs} listId={listId} logoUrl={props.logoUrl} />
                                        </Col>
                                    </Row>
                                </div>
                                {props.jobList.jobs[0] && <JobTitle>
                                    {props.jobList.jobs[0].title}
                                    {previewMode && <Preview />}
                                </JobTitle>}
                                {props.jobList?.subtitleOnJobPosting && <DetailsJobSubtitle className={"ListDetailsJobSubtitle"}>
                                {props.jobList?.jobs[0].subtitle}
                                </DetailsJobSubtitle>}
                                <Formik
                                    validationSchema={schema}
                                    onSubmit={submitForm}
                                    initialValues={initialValues}
                                >
                                    {({ handleSubmit, errors,}) => (
                                        <Form noValidate onSubmit={handleSubmit}>

                                            {props.children}

                                            <Field component={PrivacyConsentSubForm} dataSecurityUrl={dataSecurityUrl} />

                                            <Field component={HoneyPotSubForm} />
                                            <div style={{ paddingTop: "30px", display: "flex", justifyContent: "center" }}>
                                                <CustomButton
                                                    variant="primary"
                                                    type="submit"
                                                    colors={colors}
                                                >Bewerbung absenden</CustomButton>
                                            </div>

                                            {/* <div>
                                                {errors && Object.keys(errors).length !== 0 && <small><b>Validierungsfehler zum Debuggen, bitte ignorieren:</b> {JSON.stringify(errors, null, 2)}</small>}
                                            </div> */}

                                            <footer style={{ display: "table", margin: "auto", paddingTop: "20px" }}>
                                                <Legals colors={colors} legalNoticeUrl={legalNoticeUrl} />
                                            </footer>
                                        </Form>
                                    )}
                                </Formik>
                            </div>}

                            {/* Debug info */}
                            {/* <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
                                <p>Cookie consent: {consentGiven === null ? 'Pending' : consentGiven ? 'Accepted' : 'Denied'}</p>
                            </div> */}

                        </Col>
                    </Row>
                </Container>
            </Container>
            {props.jobList?.jobs[0].tenant.toLowerCase() === 'hering' && (props.jobList?.jobs[0].customForm !== "" ? props.jobList?.jobs[0].customForm : props.jobList?.customForm).toLowerCase() === 'standard' && !settingsDialogOpen && !consentDialogOpen &&
                <div
                    style={{
                    position: 'fixed',
                    bottom: 20,
                    left: 20,
                    fontSize: 24,
                    cursor: 'pointer',
                    zIndex: 1000
                    }}
                    onClick={openSettings}
                >
                    ⚙️
                </div>
            }
        </>
    );
}

export const FormComponent = ({ setUploadStatus, jobList, validationSchema, children, logoUrl }) => {

    return (
        <CookieConsentProvider>
            <FormComponentInner setUploadStatus={setUploadStatus} jobList={jobList} validationSchema={validationSchema} children={children} logoUrl={logoUrl} />
            <ModalContainer />
        </CookieConsentProvider>
    )
}
